module.exports = __webpack_public_path__ + "static/media/photographycarry02.92faf3e9.png";